"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALERT_TYPES = exports.ERROR_MESSAGE = exports.DEFAULT_TIMEOUT = void 0;
// CONSTANTS
/** Default timeout in ms, used if one is not provided by prop */
exports.DEFAULT_TIMEOUT = 3000;
/** Error message for default GKAlertContext state */
exports.ERROR_MESSAGE = "[GKAlertContext]: no provider defined. ";
/** Array of valid contextual alert colors, a subset of `IGKAlertProps['color']` */
exports.ALERT_TYPES = [
    "danger",
    "info",
    "primary",
    "secondary",
    "success",
    "warning",
];
